import React from 'react';
import ReactDOM from 'react-dom/client';
import demo from './demo';
import App from './App';
import reportWebVitals from './reportWebVitals';

function renderMetaboxMapping({ id = 'notionwpsync-metabox-mapping', ...props }) {
	const root = ReactDOM.createRoot(document.getElementById(id));
	root.render(
	  <React.StrictMode>
		<App { ...props } />
	  </React.StrictMode>
	);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (process.env.NODE_ENV === 'development') {
	demo(renderMetaboxMapping);
}

window.notionWPSyncRenderMetaboxMapping = renderMetaboxMapping;
